import { render, staticRenderFns } from "./DisposalOrdersModule.vue?vue&type=template&id=7d208b98"
import script from "./DisposalOrdersModule.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports